import './BlurredSingleBackground.scss'

export interface BlurredSingleBackgroundProps {
  /**
   * The color of the blurred background
   * slide 1: #FFE0F5 (fuchsia)
   * slide 2: #E8E0FF (violet)
   * slide 3: #E0FFFE (green)
   */
  color: string
}

export const BlurredSingleBackground = ({ color }: BlurredSingleBackgroundProps) => {
  return (
    <div className="blurred-single-background">
      <svg
        width="586"
        height="586"
        viewBox="0 0 586 586"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="blurred-single-background__svg"
      >
        <path
          d="M585.69 295.44C591.71 253.46 505.83 167.58 505.83 167.58L418.42 80.17C418.42 80.17 332.53 -5.72 290.56 0.3C250.28 6.09 217.57 30.18 123.87 123.87C30.18 217.57 6.07 250.3 0.3 290.56C-5.72 332.53 80.17 418.42 80.17 418.42L167.58 505.83C167.58 505.83 253.46 591.71 295.44 585.69C335.72 579.9 368.43 555.82 462.12 462.12C555.82 368.43 579.9 335.72 585.69 295.44Z"
          fill={color}
        />
      </svg>
    </div>
  )
}
